import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=1bf7df09&scoped=true"
import script from "./notFound.vue?vue&type=script&lang=js"
export * from "./notFound.vue?vue&type=script&lang=js"
import style0 from "./notFound.vue?vue&type=style&index=0&id=1bf7df09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7df09",
  null
  
)

export default component.exports